import { render, staticRenderFns } from "./ConfigSuccess.vue?vue&type=template&id=19b752a4"
import script from "./ConfigSuccess.vue?vue&type=script&lang=js"
export * from "./ConfigSuccess.vue?vue&type=script&lang=js"
import style0 from "./ConfigSuccess.vue?vue&type=style&index=0&id=19b752a4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports